const normalizeSearchValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).toLowerCase();
};

export const normalizeBirdDisplayValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
};

export const getBirdDisplayName = (bird) => {
  const name = normalizeBirdDisplayValue(bird?.name);
  const ringNumber = normalizeBirdDisplayValue(bird?.ring_number);
  const visibleName = /^bird\s+\d+$/i.test(name.trim()) ? '' : name;

  return visibleName || ringNumber || 'Unnamed Bird';
};

/**
 * Labels for showing a bird in a list row: the primary display name plus the
 * ring number to show as a separate chip — or null when the ring is already
 * what we're displaying as the name (so an unnamed bird's ring isn't shown
 * twice).
 */
export const getBirdListLabels = (bird) => {
  const displayName = getBirdDisplayName(bird);
  const ring = normalizeBirdDisplayValue(bird?.ring_number);
  const ringLabel = ring && ring !== displayName ? ring : null;
  return { displayName, ringLabel };
};

export const matchesBirdSearch = (bird, searchTerm) => {
  const term = normalizeSearchValue(searchTerm).trim();

  if (!term) {
    return true;
  }

  return [
    bird?.name,
    bird?.ring_number,
    bird?.breed,
    bird?.color,
  ].some((value) => normalizeSearchValue(value).includes(term));
};

export const filterBirdsBySearchAndSex = (birds, { searchTerm = '', sexFilter = 'all' } = {}) => {
  if (!Array.isArray(birds)) {
    return [];
  }

  return birds.filter((bird) => {
    if (sexFilter !== 'all' && bird?.sex !== sexFilter) {
      return false;
    }

    return matchesBirdSearch(bird, searchTerm);
  });
};
